<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldPagination.vue'
import NewFooterView from './New/NewPagination.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
